import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';

import { routePaths } from 'src/services/routing/routePaths';
import PasswordResetForm from 'src/components/account/PasswordResetPage/components/PasswordResetFormContainer';

import { styles } from './index.styles';

export const PASSWORD_RESET_DONE_TEXT = 'password-reset-done-text';
export const PASSWORD_RESET_INFO_TEXT = 'password-reset-info-text';

const PasswordResetContent: FC = () => {
  const { t } = useTranslation('login');

  const [done, setDone] = useState(false);

  const handleDone = () => {
    setDone(true);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h1">{t('resetPassword')}</Typography>
      <Typography
        variant="body1"
        data-test-id={
          done ? PASSWORD_RESET_DONE_TEXT : PASSWORD_RESET_INFO_TEXT
        }
        sx={{ py: 3 }}
      >
        {done ? t('resetPasswordConfirm') : t('resetPasswordInfo')}
      </Typography>
      {!done && <PasswordResetForm onDone={handleDone} />}
      <Stack direction="row" sx={{ justifyContent: 'center' }}>
        <Box sx={styles.link} component={Link} to={routePaths.LOGIN}>
          {t('common:back')}
        </Box>
      </Stack>
    </Stack>
  );
};

export default PasswordResetContent;
